module.exports = __webpack_public_path__ + "img/2025-06-11b_2.fd8ef3e9.jpg";